import { useGetNotification } from "@/entities/get-notification/fetch";
import { useAuth } from "@/shared/auth/fetch/useAuth";
import { assertNever } from "@/shared/lib/assertNever";
import { useNavigate } from "@tanstack/react-router";
import type { FreightMatching } from "@x-mile/api-contract";
import { useEffect } from "react";

export const useNotificationDetailRedirect = (id: number) => {
  const navigate = useNavigate({});

  const auth = useAuth();

  const notificationResult = useGetNotification(
    { id },
    {
      enabled: auth.session.isAuthenticated,
    },
  );

  useEffect(() => {
    if (notificationResult.data) {
      const notification = notificationResult.data.data;
      const link = createLink(notification);
      if (link) {
        navigate({ replace: true, to: link });
      } else {
        navigate({
          replace: true,
          to: "/notifications",
          search: { page: 1, perPage: 50 },
        });
      }
    }
  }, [notificationResult.data, navigate]);

  return;
};

const createLink = (notification: FreightMatching.schemas.Notification) => {
  switch (notification.payload.type) {
    // 荷主向け
    case "delivery_proposal_created":
      return notification.payload.deliveryProposalId
        ? `/shipper/delivery-proposals/${notification.payload.deliveryProposalId}`
        : undefined;
    case "contract_proposal_rejected":
    case "contract_concluded_created":
      return notification.payload.draftId
        ? `/shipper/cargos/${notification.payload.draftId}`
        : undefined;
    // 車主向け
    case "delivery_proposal_rejected":
    case "contract_proposal_created":
    case "delivery_request_files_uploaded":
      return notification.payload.deliveryProposalId
        ? `/carrier/cargos/${notification.payload.draftId}`
        : undefined;
    default:
      assertNever(notification.payload);
      throw new Error(
        `Unknown notification payload type: ${JSON.stringify(notification.payload)}`,
      );
  }
};
